import axios from 'axios'
import store from 'store'
import qs from 'qs'
import {
  VueAxios
} from './axios'

const TOKEN = 'token'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.BASE_API,
  // baseURL: 'http://127.0.0.1:9008',
  // baseURL: '/api', // 路由重定向解决跨域问题
  timeout: 1000*60*30 // 请求超时时间 30分钟
})

// 异常拦截处理器-无效
const errorHandler = (error) => {
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  const token = store.get(TOKEN)
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Access-Token'] = token
  }
  // config.headers['Content-Type'] = 'text/html;charset=utf-8'
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  // config.headers['Access-Control-Allow-Origin'] = '*'
  config.data = qs.stringify(config.data) // 将数据处理成key: value 的形式
  // 将url前缀进行剪切判断
  config.method = config.url.substr(0, 3) === 'get' ? 'get' : 'post' // 判断请求方式
  config.url = config.url.substr(0, 3) === 'get' ? config.url.substr(4) : config.url.substr(5) // 剪切url
  return config
}, errorHandler)

// 捕捉响应值
request.interceptors.response.use((response) => {
  if (response.data.code === 1001 || response.data.code === 1002 || response.data.code === 1003) {
    store.remove('token')
    location.href="/#/login"
  }else if (response.data.code === 1005){
    if (confirm("您还不是团队会员,是否前去充值或申请试用") === true) {
      window.open("/#/member")
      return
    }
  }
  return response.data
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}



// WEBPACK FOOTER //
// ./src/utils/request.js